import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AppThemeProvider } from './theme/theme';
import AuthPage from './pages/AuthPage';
import LanguageRouteWrapper from './components/Layouts/LanguageRouteWrapper';
import SurfaceSelectorPage from './pages/SurfaceSelectorPage';
import AuthPathRedirect from './components/AuthPathRedirect';
import RootLangRedirect from './components/RootLangRedirect';
import { getPreferredLanguage } from './i18n/language';

const App: React.FC = () => {
  return (
    <AppThemeProvider>
      <Routes>
        <Route path="/" element={<RootLangRedirect />} />

        <Route path="/select" element={<Navigate to={`/${getPreferredLanguage()}/select`} replace />} />

        <Route path="/reset" element={<AuthPathRedirect segment="reset" />} />
        <Route path="/register" element={<AuthPathRedirect segment="register" />} />
        <Route path="/verify" element={<AuthPathRedirect segment="verify" />} />

        {/* React Router v6 doesn't support regex params like :lang(en|fr); validate inside wrapper. */}
        <Route path="/:lang" element={<LanguageRouteWrapper />}>
          <Route index element={<AuthPage />} />
          <Route path="select" element={<SurfaceSelectorPage />} />
          <Route path="*" element={<AuthPage />} />
        </Route>

        <Route path="*" element={<Navigate to={`/${getPreferredLanguage()}`} replace />} />
      </Routes>
    </AppThemeProvider>
  );
};

export default App;

